import { Action, createReducer, on } from '@ngrx/store';
import { IGlimpseReport } from 'src/app/modules/customer-shared/models/IGlimpseReport';
import * as fromActions from './anonymous-report.actions';
import { AnonymousUser } from 'src/app/modules/report-components/models/AnonymousUser';

export interface AnonymousReportState {
  report: IGlimpseReport | null;
  loading: boolean;
  error: string | null;
  user: AnonymousUser | null;
}

export const initialAnonymousReportState: AnonymousReportState = {
  report: null,
  loading: false,
  error: null,
  user: null
};

const reducer = createReducer(
  initialAnonymousReportState,
  on(fromActions.loadReport, (state, action) => ({
    ...state,
    loading: true,
    error: null as string | null,
    report: null as IGlimpseReport | null,
    user: null as AnonymousUser | null
  })),
  on(fromActions.setCurrentReport, (state, action) => ({
    ...state,
    report: action.report,
    loading: false,
    error: null as string | null,
    user: action.user
  })),
  on(fromActions.reportLoadError, (state, { error }) => ({
    ...state,
    error,
    loading: false,
    report: null as IGlimpseReport | null
  }))
);

export function anonymousReportReducer(state: AnonymousReportState | undefined, action: Action) {
  return reducer(state, action);
}
